import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "dataTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('doe.titre')) + " ", 1),
          _createVNode(_component_ReglePastille, { cle: "doe.definition" })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, [
              _createTextVNode(_toDisplayString(_ctx.getTitreTableau) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "doe.portee" })
            ])
          ]),
          (_ctx.tableData.length === 0 && _ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                key: 0,
                class: "loader"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                ref: "content",
                class: "datatable-container",
                onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
              }, [
                _createVNode(_component_DataTable, {
                  isLoading: _ctx.isLoading,
                  noDataText: _ctx.$t('search.notFound'),
                  tableData: _ctx.tableData,
                  tableHeader: _ctx.tableHeader,
                  onSelect: _ctx.doSelect,
                  onSort: _ctx.doSort
                }, null, 8, ["isLoading", "noDataText", "tableData", "tableHeader", "onSelect", "onSort"])
              ], 544))
        ])
      ])
    ]),
    (_ctx.isPdfLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}